import { STATUS } from "@/lib/format";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.agendado;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};
